import React from 'react';

const ViewTxnArrowIcon = ({ fill = 'currentColor', width = '12', height = '12' }) => (
    <svg viewBox="0 0 12 12" width={width} height={height} aria-hidden="true">
        <circle cx="6" cy="6" r="6" fill={fill} />
        <path
            d="M4.3 7.7 7.7 4.3M4.9 4.3h2.8v2.8"
            stroke="white"
            strokeWidth="1.2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ViewTxnArrowIcon;
